export default {
  common: {
    chiller: "Refroidisseur",
    chilledWaterPump: "Pompe à eau réfrigérée",
    coolingTower: "Tour de refroidissement",
    nextStep: "Étape suivante",
    previousStep: "Étape précédente",
    objective: "Objectif",
    preRetrofit: "État avant rénovation",
    postRetrofit: "État après rénovation",
    retrofitSetup: "Configuration de la rénovation",
    equipmentRated: "Équipement noté/évalué",
    equipmentConfig: "Équipement et configuration",
    retrofitSummary: "Résumé de la rénovation",
    cwp: "CWP (Pompe à eau réfrigérée)",
    condenderWaterPump: "Pompe à eau de condensation",
    chwp: "CHWP (Pompe à eau de refroidissement)",
    ct: "CT (Tour de refroidissement)",
    other: "Autre",
    otherEquipment: "Autre équipement",
    chillerOneNos: "Refroidisseur (1 unité)",
    condenderWaterPumpOneNos: "Pompe à eau de condensation (1 unité)",
    chilledWaterPumpOneNos: "Pompe à eau réfrigérée (1 unité)",
    coolingTowerFanOneNos: "Tour de refroidissement (1 unité)",
    controlOptimization: "Optimisation du contrôle",
    commonHeader: "Collecteur commun",
    dedicatedOneOnOne: "Dédié (1-1)",
    pleaseInput: "Veuillez saisir",
    pleaseEnterHere: "Veuillez entrer ici",
    cancel: "Annuler",
    confirm: "Confirmer",
    years: "Années",
    noProjectInfo: "Aucune information sur le projet",

    pleaseInputData: "Veuillez entrer les données",
    systemOptionRequired: "Les options système sont requises",
    proposedEquipmentRequired: "Équipement à recommander",

    profileEquipmentSetting: "Paramètres d'équipement de profil",
    Total: "Total"
  },
  objective: {
    projectObjective: "Objectif du projet",
    chillerEfficiency: "Efficacité du refroidisseur",
    chillerPlantEfficiency: "Efficacité de la centrale frigorifique",
    heatingEfficiency: "Efficacité du chauffage",
    heatingPlantEfficiency: "Efficacité de la centrale de chauffage",
    chillerHeatingEfficiency: "Efficacité du refroidisseur en mode chauffage",
    pleaseSelectAProjectObjective: "Veuillez sélectionner un objectif de projet",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: " ( 1 - 1 ) ou Centrale",
    projectName: "Nom du projet",
    doYouWantSave: "Voulez-vous enregistrer vos données dans le cloud avant de fermer ?",
    start: "Démarrer",
    quickNavigation: "Navigation rapide",
    mainMenu: "Menu principal",

    establishBaseline: "Établir une base (Pré-rénovation)",
    profile: "Données personnelles",
    siteObservation: "Observation sur le terrain",
    equipmentSpecification: "Spécifications de l'équipement",
    baselineInput: "Entrée de base",
    summary: "Résumé",
    generateReport: "Générer un rapport",

    finalizeYourProposal: "Option de solutions (Post rénovation)",
    finalizeAnalysis: "Finaliser l'analyse",
    retrofitSetup: "Paramètres de modification",
    equipmentConfig: "Équipement et configuration",
    financialAnalysis: "Analyse financière",
    proposedConfig: "Configuration proposée",
    systemOption: "Option système",
    ProfileEquipment: "Profil et équipement",
    baselinePreview: "prévisualisation de base",
    profileEquipment: "Équipement de profil",
    selectProposedEquipments: "Sélectionner les équipements proposés",
    pleaseSelectEquipments: "Veuillez sélectionner les équipements.",

    clusterSetting: "réglage du cluster",
    generateOption: "Générer une option",

    baselineConfig: "Configuration de base",
    monthlyBaseline: "Base mensuelle"
  },
  setup: {
    systemOption: "Option système",
    chillerOnly: "Refroidisseur seulement",
    chillerWithAssociatedEquipment: "Refroidisseur avec équipement associé",
    controlOnly: "Contrôle seulement",
    proposedLayout: "Disposition proposée",
    series: "Série",
    parallel: "Parallèle",
    proposedEquipment: "Équipement proposé"
  },
  rated: {
    newEquipment: "Nouvel équipement",
    ratedInputPower: "Puissance d'entrée nominale",
    ratedCoolingCapacity: "Capacité de refroidissement nominale",
    chillerLabel: "Étiquette du refroidisseur",
    type: "Type",
    chillerBrandModel: "Marque et modèle du refroidisseur",
    yearInstalled: "Année d'installation",
    ratedDesignFlowRate: "Débit nominal de conception",
    pressureHead: "Hauteur de manomètre",
    vfd: "Si un variateur de fréquence est installé",
    yes: "Oui",
    no: "Non",
    noofFansCT: "Nombre de ventilateurs/CT",
    equipmentLabel: "Étiquette de l'équipement",
    category: "Catégorie",
    brand: "Marque",
    otherEquipment: "Autre équipement",
    inputEcatPerformanceData: "Saisir les données de performance Ecat",
    load: "Charge",
    coolingLoad: "Charge de refroidissement",
    inputPower: "Puissance d'entrée",
    chillerWaterPumpLabel: "Étiquette de la pompe à eau réfrigérée",
    ratedMotorFrequency: "Fréquence nominale du moteur",
    minimumMotorFrequency: "Fréquence minimale du moteur",
    motor: "Moteur",
    applicableChiller: "Refroidisseur applicable",
    condenserWaterPumpLabel: "Étiquette de la pompe à eau de condensation",
    coolingTowerLabel: "Étiquette de la tour de refroidissement",
    ratedFanFrequency: "Fréquence nominale du ventilateur",
    minimumFanFrequency: "Fréquence minimale du ventilateur",
    totalRatedFanPowerPerCT: "Puissance nominale totale du ventilateur par CT",
    heatRejectionCapacityPerCT: "Capacité de rejet de chaleur par CT",
    chillerLabelRequired: "L'étiquette du refroidisseur est obligatoire",
    yellowBlockRequired: "Le bloc jaune est obligatoire",
    labelRequired: "L'étiquette est obligatoire",
    maximumQuantity: "Quantité maximale",

    chilledWaterSupplyTemp: "Température d'alimentation en eau refroidie",
    outdoorAirTemp: "Température de l'air extérieur",

    condenserWaterSupplyTemp: "Température d'alimentation en eau du condensateur",

    singleChillerSellingPrice: "Prix de vente de refroidisseur unique",

    singleCHWPSellingPrice: "Prix de vente CHWP unique",
    singleCWPSellingPrice: "Prix de vente CWP unique",
    singleCTSellingPrice: "Prix de vente CT unique",

    singlePrice: "Prix de vente unique"
  },
  summary: {
    chooleYourPreference: "Choisissez votre préférence",
    higherEfficiencyImprovement: "Améliorer l'efficacité",
    lowerInvestment: "Investissement plus faible",
    higherCostSaving: "Économie de coûts plus élevée",
    shorterPaybackPeriod: "Période de remboursement plus courte",
    option: "Option",
    efficiencyImprovement: "Amélioration de l'efficacité",
    returnOnInvestment: "Retour sur investissement",
    costSavingsPerYear: "Économie de coûts par an",
    paybackPeriod: "Période de remboursement",
    optionDetails: "Détails de l'option",
    postRetrofitEfficiency: "Efficacité après rénovation",
    totalEnergySavingsPerYear: "Économie totale d'énergie par an",
    investmentAnalysis: "Analyse d'investissement (réel)",
    capex: "CAPEX",
    sellingPrice: "Prix de vente",
    OverallProjectPrice: "Prix global du projet",
    chillerCooling: "Refroidissement par refroidisseur",
    chillerHeatPump: "Pompe à chaleur refroidisseur",
    calculate: "Calculer",
    proposedConfig: "Configuration proposée",
    projectIntroduction: "Introduction du projet",
    assumptions: "Hypothèses",
    chillerPlant: "Installation de refroidissement",
    chillerPlantConfig: "Configuration de l'installation de refroidissement",
    peakBuildingCoolingLoad: "Charge de refroidissement maximale du bâtiment",
    designChilledWaterSupplyTemp: "Température de distribution de l'eau réfrigérée conçue",
    designCondenserWaterSupplyTemp: "Température de distribution de l'eau de condensation conçue",
    energyConservationMeasures: "Mesures de conservation de l'énergie",
    pumpingConfig: "Configuration de pompage",
    designFlowRate: "Débit conçu",
    designPressureHead: "Tête de pression conçue",
    vfdFitted: "VFD installé",
    chillerConfig: "Configuration du refroidisseur",
    condenserWaterPump: "Pompe à eau de condensation",
    coolingTowerConfig: "Configuration de la tour de refroidissement",
    heatRejectionCapacity: "Capacité de rejet de chaleur",
    designCoolingTowerApproach: "Approche de la tour de refroidissement conçue",
    generateReport: "Générer un rapport",
    confirmCalculation: "Confirmer le calcul",
    doYouNeedCalculationAgain: "Le résultat du calcul existe déjà. Avez-vous besoin de recalculer ?",
    recalculate: "Recalculer",
    coolingTower: "Tour de refroidissement",
    chiller: "Refroidisseur",
    chilledWaterPump: "Pompe à eau réfrigérée",
    fillValidNumericalValue: "Veuillez remplir une valeur numérique valide",

    runningNumber: "Numéro d'exécution"
  },
  profileMap: {
    associatedCT: "Cartographie de la tour de refroidissement",
    associatedCWP: "Cartographie CWP",
    associatedCHWP: "Cartographie CHWP",
    profileId: "Id de profil",
    donotNeedmanipulate: "En mode automatique, vous n'avez pas besoin de manipuler le profil.",

    automatic: "Automatiquement",
    manual: "Le manuel",
    pathAndMethod: "Chemins et méthodes",
    months: "Mois",
    running: "Courir",
    daysPerMonth: "Jours / mois",
    chiller: "Le refroidisseur"
  }
  // reportFocusDlg: {
  //   selectCustomerReportingFocus: "Sélectionner l’orientation du rapport client",
  //   roiLedSummary: "Résumé axé sur le ROI",
  //   roiLedSummaryDetails: "À utiliser lorsque les coûts d’investissement, les économies réalisées et la période de retour sur investissement sont disponibles.",
  //   efficiencyImprovementLedSummary: "Résumé axé sur l’amélioration de l’efficacité",
  //   efficiencyImprovementLedSummaryDetails:
  //     "À utiliser lorsque la décision repose principalement sur l’amélioration de l’efficacité énergétique ou lorsque les données de ROI ne sont pas disponibles ou pertinentes."
  // }
}



// WEBPACK FOOTER //
// ./src/locale/post/fr.js